import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { pmrProgramOptions } from "util/DataList";

// In-memory cache so multiple components don't re-fetch
let cachedOptions = null;

const useCustomPmrPrograms = () => {
  const [options, setOptions] = useState(cachedOptions || pmrProgramOptions);

  useEffect(() => {
    if (cachedOptions) return;

    const fetchCustomPrograms = async () => {
      try {
        const snapshot = await getDocs(collection(db, "customPmrPrograms"));
        const staticValues = new Set(pmrProgramOptions.map((o) => o.value));
        const customOptions = [];

        snapshot.forEach((doc) => {
          const { name } = doc.data();
          if (name && !staticValues.has(name)) {
            customOptions.push({ value: name, label: name });
          }
        });

        const merged = [...pmrProgramOptions, ...customOptions];
        cachedOptions = merged;
        setOptions(merged);
      } catch (err) {
        // Graceful fallback: just use the static list
        console.error("Failed to fetch custom PM&R programs:", err);
      }
    };

    fetchCustomPrograms();
  }, []);

  return options;
};

export default useCustomPmrPrograms;
